<div *ngIf="loadingInProgress$ | async" class="d-flex justify-content-center">
  <app-progress-spinner></app-progress-spinner>
</div>
<div [hidden]="loadingInProgress$ | async">
  <ng-container *transloco="let t; read: 'conversations-page'">
    <!-- Feature Off -->
    <app-conversations-feature-not-enabled
      *ngIf="(conversationConfig | async) === undefined"
    ></app-conversations-feature-not-enabled>

    <!-- Feature On -->
    <p-tabView *ngIf="(conversationConfig | async) !== undefined">
      <p-tabPanel header="{{ t('conversations') }}">
        <app-conversation-logs-query-editor></app-conversation-logs-query-editor>
      </p-tabPanel>
    </p-tabView>
  </ng-container>
</div>
